import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.e6{gap:0.25rem;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ag{justify-content:space-between;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.e7{color:var(--brand-primary);}.ssr-plugin'
import { styled, type Style } from 'inlines'
import type { ReactNode } from 'react'
import { Text } from '../typography/Text'
import { Tooltip } from '../tooltip/Tooltip'

export type InputFieldProps = {
  children: ReactNode
  label?: string
  description?: ReactNode
  labelStyle?: Style
  labelRight?: ReactNode
  tooltipText?: string
  required?: boolean
  errorMessage?: string
  style?: Style
  gap?: string | number
}

export const InputField = ({
  children,
  label,
  description,
  labelStyle,
  labelRight,
  tooltipText,
  required,
  errorMessage,
  style,
  gap = '0.38rem',
}: InputFieldProps) => {
  const hasLabelRow = !!(label || labelRight)
  return (
    <styled.div className="a b r"
      style={{
        gap,
        '&:has(:disabled)': {
          cursor: 'not-allowed',
        },
        ...style,
      }}
    >
      {(hasLabelRow || description) && (
        <div className="a b r e6"
        >
          {hasLabelRow && (
            <div className="a t ag u"
            >
              {label && (
                <Text.Medium
                  style={{ color: 'var(--palette-blue-500)', ...labelStyle }}
                >
                  {label}
                  {required && ' '}
                  {required && (
                    <span className="e7">
                      *
                    </span>
                  )}
                  {tooltipText && <Tooltip content={tooltipText} />}
                </Text.Medium>
              )}
              {labelRight}
            </div>
          )}
          {description && (
            <Text.Small color="var(--palette-blue-600)">
              {description}
            </Text.Small>
          )}
        </div>
      )}
      {children}
      {errorMessage && <Text.FormError>{errorMessage}</Text.FormError>}
    </styled.div>
  )
}
